import React from "react";
import { observer, inject } from "mobx-react";
import { Row, Col, Table, Button, Form, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { STORE_CUSTOMER_ORDERS, STORE_PRINT } from "../../../constants";
import { CustomerOrdersStore, CustomerOrderShortDetails, PrintStore } from "../../../stores";
import { formatDate, formatMoney, formatShortDate } from "../../../common/Formatting";
import { wrapCheckbox } from "../../../common/FormChangeWrapper";
import { AddPaymentModal } from "./AddPaymentModal";

interface IProps {
    isOpened: boolean,
    onClose: () => void,
    orderGuid: string,
}

interface IState {
    isOpened: boolean,
    addPaymentModalIsOpened: boolean,
    orderNumber?: number,
    orderDate?: Date,
    demandedSum: number,
    payedSum: number,
    orderDetails?: CustomerOrderShortDetails
}


type Props = IProps;

@inject(STORE_CUSTOMER_ORDERS, STORE_PRINT)
@observer
export class ShortCustomerOrderModal extends React.Component<Props, IState> {
    constructor(props: Props) {
        super(props);
        this.state = {
            addPaymentModalIsOpened: false,
            isOpened: this.props.isOpened,
            demandedSum: 0,
            payedSum: 0
        };
    }

    ordersStore = (this.props as any)[STORE_CUSTOMER_ORDERS] as CustomerOrdersStore;
    printStore = (this.props as any)[STORE_PRINT] as PrintStore;

    componentDidMount() {
    }

    componentDidUpdate(prevProps: Props, prevState: IState, snapshot: any) {

        if (this.props.isOpened && (!prevProps.isOpened || prevProps.orderGuid != this.props.orderGuid)) {

            this.ordersStore.loadOrderShort(this.props.orderGuid, (shortOrder: CustomerOrderShortDetails) => {
                this.setState({
                    isOpened: true,
                    orderNumber: shortOrder.orderNumber,
                    orderDate: shortOrder.dateCreate,
                    orderDetails: shortOrder,
                    demandedSum: shortOrder.positions.filter(w => w.statusCategoryId == 2/*отгружено*/).reduce((a: number, b) => a + (b.cost * b.count), 0),
                    payedSum: shortOrder.payments.filter(w => w.isIncoming).reduce((a: number, b) => a + (b.sum), 0)
                });


            });
        }
    }
    private openAddPaymentModal = () => {
        this.setState({
            addPaymentModalIsOpened: true,
            isOpened: false
        })
    }

    private openPrintOrderForm = () => {
        if (this.state.orderDetails != undefined) {

            const positions = this.state.orderDetails.positions;
            console.log(this.state);
            console.log(this.state.payedSum);
            this.printStore.drawForm("ContractOrder", {
                orderNumber: this.state.orderDetails.orderNumber,
                orderDate: this.state.orderDetails.dateCreate,
                payedSum: this.state.payedSum,
                positions: positions,
                sellerName: "",
                customerName: this.state.orderDetails.customerName,
                customerPhone: this.state.orderDetails.customerPhone,
            });
            setTimeout(() => {
                window.print();
            }, 400);
        }
    }

    onPositionChecked = (index: number, checked: boolean) => {
        if (this.state.orderDetails != undefined) {
            const positions = this.state.orderDetails.positions.map((w, idx) => {
                if (idx === index)
                    return Object.assign({}, w, { isChecked: checked });
                return w;
            });
            this.setState({
                orderDetails: Object.assign({}, this.state.orderDetails, { positions: positions })
            })
        }
    }

    onAllPositionChecked = (checked: boolean) => {
        if (this.state.orderDetails != undefined) {
            const positions = this.state.orderDetails.positions.map((w, idx) => {
                return Object.assign({}, w, { isChecked: checked });
            });
            this.setState({
                orderDetails: Object.assign({}, this.state.orderDetails, { positions: positions })
            })
        }
    }

    onCacheInAdded = (sum: number) => {
        if (this.state.orderDetails != undefined) {
            const payments = this.state.orderDetails.payments;
            payments.push({
                dateCreate: new Date(),
                sum: sum,
                isCache: true,
                isIncoming: true,
                paymentTypeId: 2,
                paymentTypeName: "Оплата в ТВ наличкой"
            });
            const payedSum = payments.filter(w => w.isIncoming).reduce((a: number, b) => a + (b.sum), 0)
            this.setState({
                orderDetails: Object.assign({}, this.state.orderDetails, { payments: payments }),
                payedSum: payedSum
            })
        }
    }

    printCheckue = (sum: number) => {
        if (this.state.orderNumber != undefined)
            if (window.confirm("Вы хотите отправить чек в налоговую и распечатать его! Продолжить?")) {
                this.ordersStore.printCheque(sum, this.state.orderNumber);
            }
    }

    render() {
        const payments = this.state.orderDetails != undefined ? this.state.orderDetails.payments || [] : [];

        return [<Modal key={1} show={this.state.isOpened} onHide={() => {
            this.setState({ isOpened: false });
            this.props.onClose();
        }} className="modal-xxl" >
            <Modal.Header closeButton>
                <Modal.Title>
                    Детали заказа №{this.state.orderNumber} от {formatShortDate(this.state.orderDate || new Date())}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {this.state.orderDetails == undefined ? [] :
                    [<Row key={1}>
                        <Col sm="6">
                            <Table bordered size="sm">
                                <tbody>
                                    <tr>
                                        <th style={{ width: "200px" }}>Клиент</th>
                                        <td className="text-center" style={{ width: "300px" }}>
                                            {`${this.state.orderDetails.customerName || "фио не указано"}`} <br /> {`тел. ${this.state.orderDetails.customerPhone}`}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Дата заказа</th>
                                        <td className="text-center">{formatDate(this.state.orderDetails.dateCreate)}</td>

                                    </tr>
                                    <tr>
                                        <th>Сумма заказа</th>
                                        <td className="text-center">{this.state.orderDetails.orderSum} руб.</td>
                                    </tr>
                                    <tr>
                                        <th>Печатать</th>
                                        <td className="text-center">
                                            <Button
                                                className="btn-xs"
                                                variant="primary"
                                                onClick={this.openPrintOrderForm}
                                                title="Печатать договор-заказ"
                                            >
                                                <FontAwesomeIcon icon="file-signature" />
                                            </Button>
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </Col>
                        <Col sm="6">
                            <Table className="table-xxs" bordered striped>
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Тип платежа</th>
                                        <th className="text-center">Дата</th>
                                        <th className="text-center">Сумма</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {payments.length > 0 ? payments.map((w, index) => <tr key={index}
                                        className={w.isIncoming ? "bg-success" : "bg-warning"}>
                                        <td className="text-center">{w.isCache ? <FontAwesomeIcon icon="money-bill-wave" title="Наличка" /> :
                                            <FontAwesomeIcon icon="credit-card" title="Безнал" />}</td>
                                        <td>{w.paymentTypeName}</td>
                                        <td className="text-center">{formatDate(w.dateCreate)}</td>
                                        <td className="text-center">{formatMoney(w.sum)}</td>
                                        <td className="text-center">{w.isCache && w.isIncoming ? <Button
                                            className="btn-xs"
                                            variant="primary"
                                            onClick={() => this.printCheckue(w.sum)} title="Распечатать чек" >
                                            <FontAwesomeIcon icon="file-signature" />
                                        </Button> : []}</td>
                                    </tr>) : <tr>
                                        <td colSpan={4}>Нет оплат</td>
                                    </tr>}
                                </tbody>
                            </Table>
                            <Table bordered className="table-xxs">
                                <tbody>
                                    <tr>
                                        <th style={{ width: "200px" }}>Оплачено</th>
                                        <td className="text-center" style={{ width: "300px" }}>
                                            {formatMoney(payments.filter(w => w.isIncoming).reduce((prev, curr) => prev + curr.sum, 0))}
                                            <Button className="btn-xs pull-right" style={{ marginLeft: "-150px" }} variant="primary"
                                                onClick={this.openAddPaymentModal}
                                                disabled={this.state.orderDetails.orderSum - this.state.payedSum <= 0}
                                            >{' '}
                                                <FontAwesomeIcon icon="plus" />
                                                Добавить платеж
                                            </Button>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Отгружено</th>
                                        <td className="text-center">{formatMoney(this.state.demandedSum)}</td>

                                    </tr>
                                </tbody>
                            </Table>
                        </Col>
                    </Row>,
                    <Row key={2}>
                        <Col md={12}>
                            <Table striped bordered className="table-xxs">
                                <thead>
                                    <tr>
                                        <th style={{ width: "50px", textAlign: "center" }}>
                                            <Form.Check type="checkbox" checked={this.state.orderDetails.positions.filter(w => !w.isChecked).length == 0} onChange={wrapCheckbox((fieldName: string, value: string, checked: boolean) => {
                                                this.onAllPositionChecked(checked);
                                            })} />
                                        </th>
                                        <th className="text-center">№</th>
                                        <th className="text-center">Бренд</th>
                                        <th className="text-center">Артикул</th>
                                        <th>Описание</th>
                                        <th className="text-center">Статус</th>
                                        <th className="text-center">Количество</th>
                                        <th className="text-center">Цена</th>
                                        <th className="text-center">Сумма</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.orderDetails.positions.map((item, index) => <tr key={index}>
                                        <td className="text-center">
                                            <Form.Check type="checkbox" checked={item.isChecked} onChange={wrapCheckbox((fieldName: string, value: string, checked: boolean) => {
                                                this.onPositionChecked(index, checked);
                                            })} />
                                        </td>
                                        <td className="text-center">{index + 1}</td>
                                        <td className="text-center">{item.brand}</td>
                                        <td className="text-center">{item.article}</td>
                                        <td>{item.description}</td>
                                        <td className="text-center" style={{ backgroundColor: item.statusColor }}>{item.statusName}</td>
                                        <td className="text-center">{item.count}</td>
                                        <td className="text-center">{formatMoney(item.cost)} руб.</td>
                                        <td className="text-center">{formatMoney(item.count * item.cost)} руб.</td>
                                    </tr>)}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>]
                }
            </Modal.Body>

        </Modal >,
        <AddPaymentModal key="2"
            isOpened={this.state.addPaymentModalIsOpened}
            orderSum={this.state.orderDetails != undefined ? this.state.orderDetails.orderSum : 0}
            payedSum={this.state.payedSum}
            maxSum={this.state.orderDetails != undefined ? (this.state.orderDetails.orderSum - this.state.payedSum) : 0}
            orderId={this.state.orderDetails != undefined ? this.state.orderDetails.orderNumber : -1}
            onClose={() => {
                this.setState({
                    addPaymentModalIsOpened: false,
                    isOpened: true

                })
            }}
            onCacheInAdded={this.onCacheInAdded}
        />
        ]
    }
}